import {
  Component,
  ChangeDetectionStrategy,
  effect,
  EffectRef,
  inject,
  Injector,
  OnDestroy,
  signal, computed
} from '@angular/core';
import { SurveyDialogComponent } from '../../modules/shared/survey-dialog/survey-dialog.component';
import { DialogRestService } from '../../core/services/api/dialog.rest-service';
import { DialogService } from '../../core/services/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { MatomoService } from '../../core/services/matomo.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { firstValueFrom, Subject } from 'rxjs';
// import {toSignal} from '@angular/core/rxjs';
import { filter, takeUntil, take } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FeedbackComponent } from '../../modules/shared/feedback/feedback.component';
import { AuthService } from '../../core/services/api/auth.service';
import { UserService } from '../../core/services/user.service';
import {
  CommunicationDashDialogComponent
} from '../../modules/shared/communication-dash-dialog/communication-dash-dialog.component';
import { CommunicationRestService } from '../../core/services/api/communication.rest-service';
import { OpeningHoursDialogComponent } from '../../modules/shared/opening-hours-dialog/opening-hours-dialog.component';
import { AccountService } from '../../core/services/api/account.service';
import { AgbPopupComponent } from '../../modules/shared/agb-popup/agb-popup.component';
import { CustomerInformationsComponent } from "../dashboard/customer-informations/customer-informations.component";
import { HeaderNotificationService } from "../../core/services/header-notification.service";
import { PreorderDialogComponent } from '../dashboard/preorder-dialog/preorder-dialog.component';
import { FluShopService } from '../../core/services/flu-shop.service';
import { ProductSuggestion } from '../../core/models/shop/pre-order-suggestion.model';
import {
  RequalificationDialogComponent
} from "../../modules/shared/requalification-dialog/requalification-dialog.component";

@Component({
  selector: 'app-dialog-popup',
  templateUrl: './dialog-popup.component.html',
  styleUrls: ['./dialog-popup.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogPopupComponent implements OnDestroy {
  public hash = window.location.hash;
  showDialog = false;
  surveyRef: any;
  feedbackRef: any;
  communicationRef: any;
  requalificationRef: any;
  openingHoursRef: any;
  agbRef: any;
  preorderRef: any;
  private ngUnsubscribe$ = new Subject<void>();
  private dialogMap = new Map<string, any[]>();
  private previousUrl = '';
  loading = true;
  private selectedDialog = null;
  private filter;
  private shownDialogs = [];
  mainIdf = '';
  private router = inject(Router);

  private headerNotificationService = inject(HeaderNotificationService);
  private userService = inject(UserService);
  public auth = inject(AuthService);
  communicationService = inject(CommunicationRestService);
  matomoService = inject(MatomoService);
  dialogService = inject(DialogService);
  dialogRestService = inject(DialogRestService);
  accountService = inject(AccountService);

  selectedIdf: any;
  private hasCustomerInformation: any = false;
  private activeDialogs: any;
  private customerInfoRef: any;
  private readonly injector = inject(Injector);
  customerInfo: any;
  private isDialogOpen = signal(false);
  private dialogFetchInProgress = signal(false);

  private initialWatcherDisposer: EffectRef | null = null;
  private initialWatcherTimeout: number | null = null;

  private navEffectRef: EffectRef | null = null;
  private notificationEffectRef: EffectRef | null = null;

  private readonly NOTIFICATION_WAIT_MS = 1000;

  private disposeSelectEffect: EffectRef | null = null;
  private disposeNotificationEffect: EffectRef | null = null;

  private navref: any;


  private selectedIdfSignal = toSignal(this.userService.selectedIdf$, {initialValue: null as any});

  constructor(
      public dialog: MatDialog,
      public route: ActivatedRoute,
      public fluShopService: FluShopService
  ) {

    this.userService.getMainIdfObservable().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(idf => {
      this.mainIdf = idf;
    });

    this.userService.selectedIdf$.subscribe(idf => {
      if (idf) {
        this.init();
      }
    });
  }

  init(): void {
    if (!this.auth.isAuthenticated()) return;

    const url = this.getFilter();
    this.filter = url;
    this.previousUrl = url;

    this.initialWatcherDisposer = effect(() => {
      const selectedIdf = this.selectedIdfSignal();
      const idf = selectedIdf?.idf ?? null;

      if (idf === null) return;
      this.headerNotificationService.setIdf(selectedIdf.idf);
      this.headerNotificationService.start(idf);
      if (this.dialogFetchInProgress()) return;

    }, {injector: this.injector});

    this.disposeSelectEffect = effect(() => {
      const selectedIdf = this.selectedIdfSignal();
      const idf = selectedIdf?.idf ?? null;

      if (idf === null) return;

      this.headerNotificationService.setIdf(selectedIdf.idf);
      this.headerNotificationService.start(idf);

      if (this.navref) {
        this.navref.unsubscribe();
      }

      this.navref = this.router.events.pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.ngUnsubscribe$)).subscribe(ev => {
        this.filter = this.getFilter();
        this.initialCheck(idf)
      });
    }, {injector: this.injector});

    this.initialWatcherTimeout = window.setTimeout(() => {
      const selectedIdf = this.selectedIdfSignal();
      const idf = selectedIdf?.idf ?? null;

      const hasNewAfter = this.headerNotificationService.hasNewMessage();
      if (hasNewAfter) {
        if (!this.isDialogOpen()) {
          this.showCustomerInformationDialog(idf);
        }
      } else {
        this.getDialog(idf);
      }
      this.clearInitialWatcher();
    }, this.NOTIFICATION_WAIT_MS);

  }

  initialCheck(idf) {
    // this.headerNotificationService.setIdf(idf);
    this.headerNotificationService.setIdf(idf);
    this.headerNotificationService.start(idf);

    if (this.dialogFetchInProgress()) return;
    if (this.headerNotificationService.hasNewMessage()) {
      this.showCustomerInformationDialog(idf);
      return;
    } else {
      this.getDialog(idf);
      return;
    }

  }


  private clearInitialWatcher() {
    if (this.initialWatcherTimeout !== null) {
      clearTimeout(this.initialWatcherTimeout);
      this.initialWatcherTimeout = null;
    }

    if (this.initialWatcherDisposer !== null) {
      this.initialWatcherDisposer.destroy();
      this.initialWatcherDisposer = null;
    }
    this.dialogFetchInProgress.set(false);
  }


  async getDialog(idf): Promise<void> {
    if (!this.filter) return;
    if (this.dialogFetchInProgress()) return;
    this.dialogFetchInProgress.set(true);

    const filter = Object.assign(this.filter);
    try {
      const resp = await firstValueFrom(this.dialogRestService.getActiveDialogsOnPage(this.filter, idf));

      let response = resp?.return_object ?? [];

      if (!response || response.length === 0) {
        this.filter = null;
        return;
      }

      this.dialogService?.setShowPopup?.(true);
      const shownDialog = sessionStorage.getItem('shownDialog');
      let selected = response;
      let sel = null;

      if (shownDialog && !this.userService.isAdmin()) {
        const existingDialogs = shownDialog.split(',');
        selected = response.filter(res => !existingDialogs.includes(`${res.id}_${idf}`));
      }

      if (selected.length === 0) {
        this.dialogFetchInProgress.set(false);
      } else if (selected.length === 1) {
        sel = selected[0];
      } else {
        sel = this.selectDialog(selected);
      }

      if (sel !== null) {
        sel['idf'] = idf;
        this.openDialogByType(sel);
      }
    } catch (err) {
    } finally {
      this.dialogFetchInProgress.set(false);
    }

  }

  private openDialogByType(dialog: any) {
    const type = dialog.dialog_popup_type;
    if (type === 'FEEDBACK') this.showFeedback(dialog);
    else if (type === 'AGB') this.showAGB(dialog);
    else if (type === 'COMMUNICATION') this.showCommunicationDialog(dialog);
    else if (type === 'OPENING_HOURS') this.showOpeningHours(dialog);
    else if (type === 'PREORDERS') this.showPreorderDialog(dialog);
    else if (type === 'REQUALIFICATION') this.showRequalifiedDialog(dialog);
    else this.showSurvey(dialog);
  }

  showSurvey(data) {
    // this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'PopUp Gesehen', data.title);
    this.surveyRef = this.dialog.open(SurveyDialogComponent,
        {
          maxWidth: '600px',
          data: data,
          autoFocus: false,
          closeOnNavigation: true
        });

    this.surveyRef.afterClosed().pipe(take(1)).subscribe(result => {
      this.selectedDialog = null;
    });

      const selectedIdf = this.selectedIdfSignal();
      const idf = selectedIdf?.idf ?? null;
      this.shownDialogs.push(`${data.id}_${idf}`);
      sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
  }

  showPreorderDialog(data) {
    const selectedIdf = this.selectedIdfSignal();
    const idf = selectedIdf?.idf ?? null;
    this.fluShopService.loadPreorderSuggestion(idf, this.fluShopService.categoryUrlForSuggestion)
        .pipe(take(1))
        .subscribe((suggestions: ProductSuggestion[]) => {
          // we only show the modal if we have any suggestion
          if (suggestions.length > 0) {
            data.suggestions = suggestions;
            data.idf = idf;
            this.preorderRef = this.dialog.open(PreorderDialogComponent,
                {
                  maxWidth: '600px',
                  data: data,
                  autoFocus: false,
                  closeOnNavigation: true
                });

            this.preorderRef.afterClosed().pipe(take(1)).subscribe(result => {
              this.selectedDialog = null;
            });

            if (data.subscription === false) {
              this.shownDialogs.push(`${data.id}_${idf}`);
              sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
            } else {
              this.dialogRestService.subscribeToDialogOffer(data.id, idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
                if (res.return_object !== null && res.error_code === null) {
                  // subscribed
                }
              });
            }
          }
        });
  }

  showRequalifiedDialog(data) {
    const selectedIdf = this.selectedIdfSignal();
    const idf = selectedIdf?.idf ?? null;
    this.accountService.isRequalified(idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      if (res['returnObject'] === false) {
        this.requalificationRef = this.dialog.open(RequalificationDialogComponent,
            {
              maxWidth: '600px',
              data: data,
              autoFocus: false,
              closeOnNavigation: true,
            });

        this.requalificationRef.afterClosed().pipe(take(1)).subscribe(result => {
          this.selectedDialog = null;
          const selectedIdf = this.selectedIdfSignal();
          const idf = selectedIdf?.idf ?? null;
          this.shownDialogs.push(`${data.id}_${idf}`);
          sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
          this.dialogFetchInProgress.set(false);
        });
      }
    });
  }

  showFeedback(data) {
    // this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'PopUp Gesehen', data.title);
    this.feedbackRef = this.dialog.open(FeedbackComponent,
        {
          maxWidth: '700px',
          data: data,
          autoFocus: false,
          closeOnNavigation: true
        });

    this.feedbackRef.afterClosed().pipe(take(1)).subscribe(result => {
      this.selectedDialog = null;
      const selectedIdf = this.selectedIdfSignal();
      const idf = selectedIdf?.idf ?? null;
      this.shownDialogs.push(`${data.id}_${idf}`);
      sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
    });
  }

  closeSurvey() {
    this.surveyRef.close();
    this.selectedDialog = null;
  }

  closeFeedback() {
    this.feedbackRef.close();
    this.selectedDialog = null;
  }


  selectDialog(dialogs) {
    const selected = [];

    const highestPrio = dialogs[0].priority;
    const prioritized = dialogs.filter(d => d.priority === highestPrio);

    if (prioritized.length === 1) {
      return prioritized[0];
    }
    selected.push(prioritized[Math.floor(prioritized.length * Math.random())]);

    return selected[0];
  }

  private showCommunicationDialog(data: any) {
    if (this.mainIdf) {
      this.communicationService.getConfigs(this.mainIdf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(configs => {
        if (configs.returnObject.length === 0) {
          // this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'PopUp Gesehen', data.title);
          this.communicationRef = this.dialog.open(CommunicationDashDialogComponent,
              {
                maxWidth: '750px',
                data: data,
                autoFocus: false,
                closeOnNavigation: true,
                disableClose: true
              });

          this.communicationRef.afterClosed().pipe(take(1)).subscribe(result => {
            this.selectedDialog = null;
            const selectedIdf = this.selectedIdfSignal();
            const idf = selectedIdf?.idf ?? null;
            this.shownDialogs.push(`${data.id}_${idf}`);
            sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
            this.dialogFetchInProgress.set(false);
          });
        }
      });
    }
  }

  showOpeningHours(selectedDialog: any) {
    this.accountService.getOpeningHours(this.selectedIdf.idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(configs => {
          const conf = configs.returnObject;

          let show = false;
          show = conf.filter(config => config.open === true).length === 0;

          if (!conf || show) {

            // this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'PopUp Gesehen', selectedDialog.title);
            selectedDialog['account'] = this.selectedIdf;
            this.openingHoursRef = this.dialog.open(OpeningHoursDialogComponent,
                {
                  maxWidth: '850px',
                  data: selectedDialog,
                  autoFocus: false,
                  closeOnNavigation: true,
                  disableClose: true
                });

            this.openingHoursRef.afterClosed().pipe(take(1)).subscribe(result => {
              this.selectedDialog = null;
              const selectedIdf = this.selectedIdfSignal();
              const idf = selectedIdf?.idf ?? null;
              this.shownDialogs.push(`${selectedDialog.id}_${idf}`);
              sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
            });
          }
        }
    );
  }

  getFilter() {
    let url = window.location.hash.replace('#/', '');
    if (url.indexOf('/') === 0) {
      url = url.substring(1).trim();
    }

    if (url.indexOf('?') > -1) {
      url = url.substring(0, url.indexOf('?')).trim();
    }

    if (url.indexOf('%3D') > -1) {
      url = url.substring(0, url.indexOf('%3D')).trim();
    }

    return url;
  }

  private showAGB(data: any) {
    if (this.dialogService.getShowPopup()) {
      this.matomoService.trackEvent('FEATUREBEZOGENE KPIs', 'PopUp Gesehen', data.title);
      this.agbRef = this.dialog.open(AgbPopupComponent,
          {
            maxWidth: '700px',
            data: data,
            autoFocus: false,
            closeOnNavigation: true,
          });

      this.agbRef.afterClosed().pipe(take(1)).subscribe(result => {
        this.selectedDialog = null;
        const selectedIdf = this.selectedIdfSignal();
        const idf = selectedIdf?.idf ?? null;
        this.shownDialogs.push(`${data.id}_${idf}`);
        sessionStorage.setItem('shownDialog', this.shownDialogs.join(','));
      });
    }
  }

  private showCustomerInformationDialog(idf) {
    this.customerInfoRef = this.dialog.open(CustomerInformationsComponent,
        {
          maxWidth: '700px',
          // data: data,
          autoFocus: false,
          closeOnNavigation: true,
          disableClose: true
        });

    this.customerInfoRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(result => {

            this.headerNotificationService.setMessageStatus(idf, result).pipe(take(1)).subscribe(status => {
                this.selectedDialog = null;
                this.dialogFetchInProgress.set(false);
                if (result === 'READ') {
                    this.router.navigate(['track-trace'], {
                        queryParams: {
                            tab: 'aktuelle-meldungen',
                            messageId: this.headerNotificationService.getCurrentMessage()?.id
                        },
                        onSameUrlNavigation: 'reload'
                    });
                }
            });
        });
        return this.customerInfoRef;
    }

  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy(): void {
    this.feedbackRef?.close();
    this.communicationRef?.close();
    this.surveyRef?.close();
    this.agbRef?.close();
    this.customerInfoRef?.close();
    this.navref?.complete();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.initialWatcherDisposer?.destroy();
    this.disposeSelectEffect?.destroy();
    this.disposeNotificationEffect?.destroy();
    this.navEffectRef?.destroy();
    this.notificationEffectRef?.destroy();
    const selectedIdf = this.selectedIdfSignal();
    if (selectedIdf?.idf) {
      this.headerNotificationService.stop(selectedIdf.idf);
    }
  }
}
